<template>
  <div class="wrapper-box">
    <div class="wrapper" @scroll="handleScroll" v-if="answer != null">
      <div class="header-wrap">
        <div class="top-box">
          <div class="new-title">{{ answer.title }}</div>
          <div class="user-info">
            <div class="user-l">
              <img class="joiner-avatar" :src="answer.joiner_avatar" />
            </div>
            <div class="user-c">
              <div class="user-name">
                <span class="name-text">{{ answer.submit_data.uname }}</span>
                <div class="position-r flexCenter" v-if="!isInApp">
                  <img @click="toMessage()" src="https://cdn-xcx-qunsou.weiyoubot.cn/material/20220308/158b6842d5dcbba4ca56d1497c7ac37c.svg" class="edit-icon" />
                  <WxLink
                    v-if="isWeixin && isMobile"
                    :wxPath="wxPath + answer.qid"
                  />
                </div>
              </div>
              <div class="record-time">{{ t_add }} 提交</div>
            </div>
            <div class="user-r" v-if="!hide_score">
              <div class="record-score" v-if="answer.temp != 3 || answer.option_score">{{ answer.submit_data.score }}</div>
              <div class="user-total" v-if="answer.temp != 3">
                总分 {{ answer.submit_data.full_score }}分
              </div>
            </div>
          </div>
          <div class="new-top" v-if="answer.temp != 3">
            <div class="top-view">
              <div class="big">{{ total }}</div>
              <div class="tip">总题数</div>
            </div>
            <div class="top-view" @click="isInApp ? '' : towronglist()">
              <div
                :class="[
                  'big',
                  !hide_score && falseCount && falseCount > 0 ? 'redColor' : ''
                ]"
              >
                {{ hide_score ? "-" : falseCount }}
              </div>
              <div class="tip">
                答错<label
                  style="margin-left: 2px;"
                  v-if="!(!answer.wrong_book && show_answer == 1) && !isInApp"
                  >></label
                >
              </div>
            </div>
            <div class="top-view" v-if="answer.temp == 2">
              <div class="big">{{ answer.submit_data.total_days }}</div>
              <div class="tip">累计答题(天)</div>
            </div>
            <div class="top-view" v-else>
              <div class="big" v-if="percent">
                {{ hide_score ? "-" : percent + "%" }}
              </div>
              <div class="tip">正确率</div>
            </div>
            <div class="top-view">
              <div class="big">{{ time }}</div>
              <div class="tip">用时</div>
            </div>
          </div>
        </div>
        <div
          class="info-box"
          v-if="answer.temp == 6 && answer.card_imgs && answer.card_imgs.length"
        >
          <div class="top">试卷内容</div>
          <swiper
            class="swiper-box"
            :indicator-dots="banner_swiper.indicatorDots"
            :interval="banner_swiper.interval"
            :duration="banner_swiper.duration"
            indicator-color="rgba(255,255,255, .5)"
            indicator-active-color="#fff"
            circular
            :current="banner_swiper.current"
          >
            <swiper-item
              v-for="(item, index) in answer.card_imgs || []"
              :key="index"
              @click="previewCardImg(item)"
            >
              <img :src="item" mode="aspectFill" class="slide-image" />
            </swiper-item>
          </swiper>
        </div>
        <div
          class="info-box"
          style="overflow: hidden;"
          v-if="
            answer.show_comments && (adv_comment.content || adv_comment.title || adv_comment.img)
          "
        >
          <div class="top" :class="toggled ? 'hideTop' : ''">答题评语<label class="toggle-btn" @click="toggled = !toggled">{{toggled ? '展开' : '收起'}}</label></div>
          <template v-if="!toggled">
            <MpBox :info="answer" :toggled="toggled" />
          </template>
        </div>
      </div>
      <div
        class="info-box"
        v-if="answer.temp == 6 && answer.card_imgs && answer.card_imgs.length"
      >
        <div class="top">试卷内容</div>
        <div class="banner">
          <van-swipe class="my-swipe" :loop="false" indicator-color="white">
            <van-swipe-item
              v-for="(item, index) in answer.card_imgs"
              :key="index"
            >
              <img
                class="slide-image"
                @dragstart.prevent
                :src="item"
                alt=""
                @click="previewImage(answer.card_imgs, index)"
              />
            </van-swipe-item>
          </van-swipe>
        </div>
      </div>

      <div
        :class="
          listContainer.length > 1 ? 'question-box' : 'active question-box'
        "
      >
        <div class="question-top" :class="{ fixed: fixSearch }">
          <div class="question-top-box">
            <div class="tab-box">
              <template v-if="answer.temp != 3">
                <div
                  class="tab-item"
                  :class="{ active: questionType == 0 }"
                  @click="changeTab(questionType == 0 ? 1 : 0)"
                >
                  全部
                </div>
                <div
                  class="tab-item"
                  :class="{ active: questionType == 1 }"
                  @click="changeTab(questionType == 0 ? 1 : 0)"
                >
                  答错
                </div>
              </template>
              <template v-else>{{
                is_my_result ? "我的回答" : "考生回答"
              }}</template>
            </div>
            <font-setting
              :showFontSetting="showFontSetting"
              :fontIndex="fontIndex"
              @changeSettingShow="changeSettingShow"
              @changefont="changefont"
            />
          </div>
        </div>
        <div
          class="wrongbook-nodata"
          v-if="
            answer.submit_data.lists &&
              questionType == 1 &&
              answer.submit_data.lists.length == 0
          "
        >
          <div>本次答题没有错题哦~</div>
        </div>

        <div
          :class="{
            'question': true, // 任何条件下都应用 'question' 类
            'card': answer.temp == 6, // 当 temp 等于 6 时应用 'card' 类
            'first': index === 0 // 当 index 等于 0 时应用 'first' 类
          }"
          v-for="(a, index) in answer.submit_data.lists"
          :key="index"
        >
          <div v-if="(a.right == 0 && questionType == 1) || questionType == 0">
            <q-item
              :a="a"
              :show_answer="show_answer"
              :has_sub="answer.has_sub"
              :temp="answer.temp"
              :pagesize="100"
              :avg_score="answer.avg_score"
              :fontIndex="fontIndex"
              :index="index"
              :page="page"
              :is_my_result="is_my_result"
              :wrongbook="answer.wrongbook"
              :is_owner="is_owner"
              :hide_score="hide_score"
              :is_admin="is_admin"
              :copy_able="book_vip"
            />
          </div>
        </div>
      </div>
      <div
        v-if="
          (answer.submit_data.lists &&
            questionType === 0 &&
            listContainer.length > 1) ||
            (answer.submit_data.lists &&
              questionType === 1 &&
              listFalseContainer.length > 1)
        "
        class="btn-page-panel"
      >
        <div
          v-on:click="otherAnswer('prev')"
          v-if="page > 1"
          class="btn-page btn-prev"
        >
          上一页
        </div>
        <div
          v-on:click="otherAnswer('next')"
          v-if="
            (questionType === 0 && page < listContainer.length) ||
              (questionType === 1 && page < listFalseContainer.length)
          "
          class="btn-page btn-next"
        >
          下一页
        </div>
      </div>
      <div class="divide-box"></div>
      <div v-if="answer && (!is_admin || (is_admin && answer.temp != 3)) && !isInApp" class="footer">
        <template v-if="is_admin">
          <div class="delete-box position-r" @click="toMessage()">
            <img class="delete-icon" src="https://cdn-xcx-qunsou.weiyoubot.cn/material/2024-11-15/2fcf403db0021f4edbed97ed66cced64.png" alt="Delete" />
            <span>删除</span>
            <WxLink
              v-if="isWeixin && isMobile"
              :wxPath="wxPath + answer.qid"
            />
          </div>
          <div class="f-detail r position-r" @click="toMessage()">
            下载答题详情
            <WxLink
              v-if="isWeixin && isMobile"
              :wxPath="wxPath + answer.qid"
            />
          </div>
        </template>
        <template v-else>
          <div class="f-detail l" @click="toDetail">答题主页</div>
          <div class="f-detail" :class="{'wrong_book': answer.wrong_book && (answer.temp != 3 && answer.temp != 6)}">
            <span v-if="answer.wrong_book && (answer.temp != 3 && answer.temp != 6)" @click="towronglist()">
              错题重练
            </span>
            <span v-else @click="toHomePage()" class="position-r">
              出题人主页
              <WxLink
                v-if="isWeixin && isMobile"
                :wxPath="ownerWxPath + answer.owner_unionid"
              />
            </span>
          </div>
        </template>
      </div>
      <van-popup
        v-model="showVersionTip"
        :style="{ borderRadius: '8px', width: '320px' }"
        closeable
        close-icon="close"
        @closed="showVersionTip = false"
      >
        <ImgDialog :src="showCodeType ? ownerSrc : settingSrc" />
      </van-popup>
    </div>
  </div>
</template>

<script>
import MpBox from "@/components/mpBox";
import questionOnly from "@/utils/questionOnly";
import { Toast, ImagePreview } from "vant";
import GzhFile from "../../components/gzhfile.vue";
import ImgDialog from "@/components/common/imgDialog.vue";

import {
  getToken,
  formatMinuteNew,
  formatDate,
  deepClone,
  jumpWrongList,
  isMobile,
  getDetailWxCode,
  getWxUrl,
  isWeixin
} from "@/utils/common";
import NavBar from "@/components/navbar";
import { font_rules } from "@/utils/config";
import FontSetting from "../../components/common/fontsetting.vue";
import qItem from "../../components/common/qItem.vue";
import WxLink from "@/components/wxLink.vue";

export default {
  components: { NavBar, MpBox, GzhFile, FontSetting, qItem, ImgDialog, WxLink },
  data() {
    return {
      fontRules: font_rules,
      showFontSetting: false,
      fontIndex: 0,
      answer: null,
      questionType: 0,
      subMessageDialog: false,
      page: 1,
      pagesize: 100,
      listContainer: [],
      listFalseContainer: [],
      showTipModal: false,
      currentEditIndex: -1,
      editedScore: 0,
      hasEdit: false,
      editScoreReason: "",
      hide_score: 0,
      show_score: false,
      fontIndex: 0,
      audit: 0,
      show_answer: 0,
      isInApp: wemeet.app.isTMWebview(),
      wrong_book: 0,
      total_wrong_count: 0,
      fixSearch: false,
      headerWrapHeight: 0,
      topHeight: 0,
      settingUrl: '',
      settingSrc: '',
      isMobile: isMobile(),
      showVersionTip: false,
      isWeixin: isWeixin(),
      wxPath: "/pages/detail/detail?qid=",
      ownerWxPath: "/pages/homepage/homepage?unionid=",
      ownerUrl: '',
      ownerSrc: '',
      showCodeType: 0,
      toggled: true
    };
  },
  mounted() {
    if (localStorage.getItem("font_index")) {
      this.fontIndex = localStorage.getItem("font_index") * 1;
    }
    this.rid = this.$route.query.rid;
    this.getResult();
    this.$el.addEventListener("scroll", this.handleScroll);
  },
  destroyed() {
    this.$el.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    async toHomePage() {
      if (this.isMobile) {
        if (!this.ownerUrl) {
          let res = await getWxUrl("pages/homepage/homepage", this.answer.owner_unionid);
          if (res) {
            this.ownerUrl = res;
          }
        }
        window.location.href = this.ownerUrl;
        return;
      } else {
        this.showCodeType = 1;
        if (!this.ownerSrc) {
          this.ownerSrc = await getDetailWxCode(this.answer.owner_unionid, 15);
        }
        this.showVersionTip = true;
      }
    },
    toDetail() {
      this.$router.push({
        name: "normalDetail",
        query: { qid: this.answer.qid }
      });
    },
    async toMessage() {
      if (this.isMobile) {
        if (!this.settingUrl) {
          let res = await getWxUrl("pages/detail/detail", this.answer.qid);
          if (res) {
            this.settingUrl = res;
          }
        }
        window.location.href = this.settingUrl;
        return;
      } else {
        this.showCodeType = 0;
        if (!this.settingSrc) {
          this.settingSrc = await getDetailWxCode(this.answer.qid);
        }
        this.showVersionTip = true;
      }
    },
    getHeaderHeight() {
      this.headerWrapHeight = document.querySelector(
        ".header-wrap"
      ).offsetHeight;
    },
    handleScroll(event) {
      // 获取滚动容器的滚动高度
      const scrollTop = event.target.scrollTop;
      let headerWrapHeight = this.headerWrapHeight;
      if (headerWrapHeight && scrollTop > headerWrapHeight) {
        if (!this.topHeight) {
          this.topHeight = headerWrapHeight;
        }
        if (!this.fixSearch) {
          this.fixSearch = true;
        }
      } else {
        if (this.fixSearch) {
          this.fixSearch = false;
        }
      }
      // 在这里处理滚动条高度的逻辑
    },
    towronglist() {
      jumpWrongList(this);
    },
    showSubDialog() {},
    prevImgs(val) {
      ImagePreview({
        images: [val],
        showIndex: false,
        loop: false,
        startPosition: 0
      });
    },
    changeSettingShow() {
      this.showFontSetting = !this.showFontSetting;
    },
    changefont(idx) {
      this.fontIndex = idx;
      localStorage.setItem("font_index", idx);
      this.showFontSetting = false;
    },
    otherAnswer(type) {
      let {
        page,
        answer,
        listContainer,
        listFalseContainer,
        questionType
      } = this;

      if (type == "prev") {
        answer.submit_data.lists =
          questionType == 0
            ? listContainer[page - 2].lists
            : listFalseContainer[page - 2].lists;
      } else {
        answer.submit_data.lists =
          questionType == 0
            ? listContainer[page].lists
            : listFalseContainer[page].lists;
      }
      this.page = type == "prev" ? page - 1 : page + 1;
      this.answer = answer;
      this.handleContentScroll();
    },
    previewImage(images, index) {
      ImagePreview({
        images: images,
        showIndex: true,
        loop: false,
        startPosition: index
      });
    },
    changeTab(type) {
      let { answer, listContainer, listFalseContainer } = this;
      if (!answer) return;
      answer.submit_data.lists =
        type == 1 ? listFalseContainer[0].lists : listContainer[0].lists;
      this.questionType = parseInt(type);
      this.page = 1;
      this.answer = answer;
      this.handleContentScroll();
    },
    handleContentScroll() {
      let top = this.topHeight ? this.topHeight : 0;
      setTimeout(() => {
        document.querySelector(".wrapper-box").scrollTo({
          top: top,
          behavior: "smooth"
        });
      }, 1);
    },
    getResult(edit) {
      let param = {
        rid: this.rid,
        access_token: getToken()
      };
      questionOnly.get("/xcx/ques/v1/result", param).then(res => {
        if (res.sta == 0) {
          var self = this;
          var r = res.data;
          r.is_answer = true;
          this.wrong_book = r.wrong_book || 0;
          this.show_answer = r.show_answer;
          var result = r.submit_data;
          this.is_audit = result.is_audit || 0;
          this.total_wrong_count = r.total_wrong_count;
          this.book_vip = r.book_vip;
          var lists = [];
          let copySubmitList = [];
          for (const i in result.data) {
            copySubmitList.push(result.data[i]);
          }
          if (
            r.temp == 2 ||
            (r.random_ques == 1 && result.data[0].options) ||
            r.random_order == 1 ||
            r.random_ques == 2
          ) {
            lists = [];
            for (const i in result.data) {
              lists.push(result.data[i]);
            }
          } else if (r.temp == 3) {
            for (const i in result.data) {
              lists.push(result.data[i]);
            }
          } else {
            r.lists.map((item, index) => {
              if (
                copySubmitList[index] &&
                (item.qqid == copySubmitList[index].id ||
                  item.id == copySubmitList[index].id)
              ) {
                item.opt = copySubmitList[index].opt;
                item.score_get = copySubmitList[index].score_get;
                item.answer = copySubmitList[index].answer;
                item.show_order = copySubmitList[index].show_order;
                item.remark = copySubmitList[index].remark;
                item.options = copySubmitList[index].options || [];
                item.options.map((oitem, oindex) => {
                  oitem.blank_input = item.opt[oindex];
                });
                item.videos = copySubmitList[index].videos;
                item.change_history = copySubmitList[index].change_history;
                item.img = copySubmitList[index].img;
                item.imgs = copySubmitList[index].imgs;
                item.parsing_imgs = copySubmitList[index].parsing_imgs;
                item.origin_img = copySubmitList[index].origin_img;
                item.origin_imgs = copySubmitList[index].origin_imgs;
                item.origin_parsing_imgs =
                  copySubmitList[index].origin_parsing_imgs;
                item.order_answer = copySubmitList[index].order_answer;
              }
            });
            lists = r.lists;
          }
          function getResultData(data, list, i) {
            let _item = {};
            if (list.id || list.qqid) {
              for (const index in data) {
                let item = data[index];
                if (list.qqid && item.id == lists[i].qqid) _item = item;
                else if (item.id == lists[i].id) _item = item;
              }
            } else _item = data[i];
            return _item;
          }
          lists.map((n, i) => {
            n.score = n.score || r.score[n.type];
            n.audit = result.is_audit;
            if (r.avg_score) n.score = r.avg_score;
            let _data = getResultData(result.data, lists[i], i);
            n.score_get = n["score_get"] || 0;
            n.img = _data["img"] && _data["img"].length ? _data["img"] : "";
            let _score = r.temp == 2 ? r.avg_score : n.score;
            n.right = _score == n.score_get ? 1 : 0;
            if (n.type == 4) n.right = n.score_get == -1 ? 1 : n.right;
            let c = "";
            if (n.options && n.options.length > 0) {
              if (r.temp === 3) n.options = _data.options;
              n.options.map((m, j) => {
                if (n.type == 3) {
                  // let temp_input = _data['opt'] && _data['opt'][j] ? filterPunctuation(_data['opt'][j]) : '';
                  let len = n.opt && n.opt.filter(item => item != "").length;
                  if (len) {
                    n.optEmpty = false;
                  } else {
                    n.optEmpty = true;
                  }

                  m.right = m.check;
                  // let temp_m = [];
                  // m.blank.map((item) => {
                  //   item = trim(item)
                  //   temp_m.push(filterPunctuation(item));
                  // })
                  // if (temp_m.indexOf(trim(temp_input)) == -1) m.right = 0
                  // else m.right = 1
                } else {
                  m.letter = String.fromCharCode(64 + parseInt(j + 1));
                  if (r.temp != 3) {
                    m.check = 0;
                    if (n["opt"] && n["opt"].indexOf(j) != -1) m.check = 1;
                  }else {
                    if(n.type < 2 && m.hasOwnProperty('blank_input')) {
                      m.other = 1;
                    }
                  }
                  if (m.right == 1) c += m.letter;
                }
              });
              n.correct = c;
            }
            n.your_answer = "";
            if (n.type == 3 || n.type == 4) {
              n.your_answer = _data["opt"] ? _data["opt"].toString() : "";
            } else {
              let opt = n["opt"];
              for (const i in opt) {
                let _letter = String.fromCharCode(64 + parseInt(opt[i]) + 1);
                n.your_answer += _letter;
              }
            }
            if (n.type == 4) {
              n.discussion = _data["opt"] ? _data["opt"][0] : "";
            }
            if (
              n.videos &&
              n.videos.length &&
              n.videos[0].url.indexOf("mp4") > -1
            ) {
              n.videoAble = true;
            }
          });
          this.total = lists.length;

          function handleLists(list, type) {
            let copyList = [];
            let lists = deepClone(list);
            lists.map((item, index) => {
              item.originIndex = index;
              if (item.change_history && item.change_history.length) {
                item.change_history.map(cItme => {
                  cItme.t_update = formatDate(
                    new Date(cItme.t_update * 1000),
                    "yyyy-MM-dd HH:mm"
                  );
                });
              }
            });
            if (type == "falseItem") {
              lists = lists.filter(item => item.right == 0);
              self.falseCount = lists.length;
            } else {
              self.totalCount = lists.length;
            }
            let listsCount = lists.length;
            if (listsCount <= 100) {
              copyList.push({
                title: listsCount > 1 ? "1-" + `${listsCount}` : 1,
                lists
              });
            } else {
              let count = lists.length / 100;
              for (let i = 0; i < count; i++) {
                if (i == 0) {
                  copyList.push({
                    title: "1-100",
                    lists: lists.slice(0, 100)
                  });
                } else {
                  let title = i == parseInt(count) ? listsCount : (i + 1) * 100;
                  copyList.push({
                    title: `${i * 100 + 1}` + "-" + title,
                    lists: lists.slice(`${i * 100}`, `${(i + 1) * 100}`)
                  });
                }
              }
            }
            return copyList;
          }

          var listContainer = handleLists(lists);
          var listFalseContainer = handleLists(lists, "falseItem");
          this.listContainer = listContainer;
          this.listFalseContainer = listFalseContainer;
          let { falseCount, totalCount } = this;
          if (edit) {
            result.lists = this.questionType
              ? listFalseContainer[page - 1].lists
              : listContainer[page - 1].lists;
            this.answer = r;
            this.percent =
              this.falseCount == 0
                ? "100"
                : (((totalCount - falseCount) / totalCount) * 100).toFixed(1);
            this.adv_comment = r.adv_comment;
          } else {
            result.lists =
              listFalseContainer[0].lists.length > 0
                ? listFalseContainer[0].lists
                : listContainer[0].lists;
            this.answer = r;
            this.percent =
              this.falseCount == 0
                ? "100"
                : (((totalCount - falseCount) / totalCount) * 100).toFixed(1);
            this.time = formatMinuteNew(result.time);
            this.t_add = formatDate(
              new Date(result.t_add * 1000),
              "yyyy-MM-dd HH:mm:ss"
            );
            this.t_start = formatDate(
              new Date(result.t_start * 1000),
              "yyyy-MM-dd HH:mm:ss"
            );
            this.show_parse = r.show_parse || "";
            this.adv_comment = r.adv_comment;
            this.is_my_result = r.is_my_result || 0;
            this.total_wrong_count = r.total_wrong_count;
            this.refresh = false;
            this.questionType = listFalseContainer[0].lists.length > 0 ? 1 : 0;
            this.is_owner = r.is_owner;
            this.is_admin = r.is_admin;
            this.hide_score =
              (r.is_admin || r.is_owner) && this.show_score ? 0 : r.hide_score;
          }
          if (!this.headerWrapHeight) {
            setTimeout(() => {
              this.getHeaderHeight();
            }, 100);
          }
        }else if(res.sta == -1 && res.errcode == 129) {
          Dialog.confirm({
            title: "提示",
            message: res.msg,
            confirmButtonText: "我知道了",
            showCancelButton: false,
            confirmButtonColor: "#1890FF"
          })
            .then(() => {
              this.$router.go(-1);
            })
        } else {
          Toast(res.msg);
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
@function rem($px) {
  @return $px / 75 + rem;
}
.wrapper-box {
  width: 100%;
  overflow-y: scroll;
}
.wrapper {
  //   overflow: hidden;
  max-width: 500px;
  min-width: 320px;
  margin: 0 auto;
  position: relative;
  height: 100vh;
}
// .pics {
//   display: inline-block;
//   margin: 8px 0 15px;
// }

.pics,
.videos {
  margin: 10px 0 15px;
}
.parsing-pics {
  margin-bottom: 0;
}

.pics img,
.videos img {
  width: 100%;
  object-fit: cover;
  cursor: pointer;
}
.videos {
  margin: 5px 0 15px;
}
.videos .videos-item {
  width: 100%;
}
.title-box {
  background-color: #fff;
  margin-bottom: 10px;
  padding: 30px 15px 0;
  line-height: 1.4;
  overflow: hidden;
}

.title {
  font-size: 20px;
  font-weight: bold;
}

.title-box .small {
  font-size: 13px;
  color: #999;
  margin: 20px 0;
}

.title-box .small span {
  margin-right: 30px;
}
.title-box .small {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.title-box .small .download_detail {
  display: flex;
  color: #1890ff;
}
.title-box .small .download_detail img {
  width: 15px;
  height: 15px;
  margin-right: 5px;
}

.question-box {
  padding: 0 15px 0;
  margin: 10px 0 15px;
  font-size: 16px;
  border-radius: 4px;
}
.active {
  // padding-bottom: 40px;
}

.question {
  word-break: break-all;
  padding: 15px;
  margin-bottom: 10px;
  background: #fff;
  border-radius: 4px;
  &.card {
    padding-bottom: 0;
  }
}
.question.first {
  border-radius: 0 0 4px 4px;
}

.question:last-child {
  border-bottom: 0;
}

.desc {
  padding: 20px 0;
  font-size: 15px;
}
.discussion img {
  width: 100%;
  margin-top: 5px;
  display: block;
  object-fit: cover;
}
.option {
  display: flex;
  display: -webkit-flex;
  font-size: 15px;
  align-items: baseline;
  margin-bottom: 20px;
}

.option:last-child {
  margin-bottom: 0;
}

.option img,
.letter {
  width: 15px;
  height: 15px;
  min-width: 15px;
  margin-right: 10px;
  display: flex;
  display: -webkit-flex;
  align-items: center;
  justify-content: center;
}

.option .view {
  flex: 1;
}

.grey {
  color: #999;
  padding-right: 5px;
}
div .grey {
  padding-top: 5px;
}

.answer {
  font-size: 16px;
}

.answer:last-child {
  padding-top: 20px;
  padding-bottom: 20px;
}

.analysis {
  margin-bottom: 5px;
}

.info-box {
  background: #fff;
  margin: 10px 0;
  padding: 15px;
  border-radius: 4px;
  font-size: 15px;
}

.info-box .top {
  border-bottom: 1px solid #eee;
  font-size: 15px;
  padding-bottom: 15px;
  margin-bottom: 15px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.info-box .bottom {
  line-height: 1.8;
}

.blank-text {
  padding-right: 10px;
}

/* footer */
.footer {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 99;
  max-width: 500px;
  margin: 0 auto;
  height: 65px;
  display: flex;
  align-items: center;
  background-color: #fff;
  border-top: 2px solid #eee;
  padding-bottom: constant(safe-area-inset-bottom);
  padding-bottom: env(safe-area-inset-bottom);
  padding-right: 15px;
  padding-left: 15px;
}

.f-home {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 45px;
  height: 45px;
  border-radius: 8px;
  background-color: #00cf97;
  margin-left: 15px;
}

.f-home img {
  width: 28px;
  height: 27px;
}

.f-detail {
  height: 45px;
  line-height: 45px;
  color: #fff;
  font-size: 48px;
  border-radius: 8px;
  background-color: #1890ff;
  text-align: center;
}

.text-red {
  color: #ff5c5c !important;
  padding-right: 2px;
}

.question-top {
  font-size: 15px;
  background: #ffffff;
  border-radius: 4px 4px 0 0;
}
.question-top-box {
  margin: 0 15px;
  border-bottom: 1px solid #eee;
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 50px;
}

.tab-item {
  font-size: 14px;
  color: #999999;
  margin-right: 15px;
}
.tab-item.active {
  color: #1890ff;
  font-weight: bold;
}

.tab-box {
  display: flex;
  align-items: center;
  cursor: pointer;
}

.typeRadio {
  background: #ffffff;
  box-sizing: border-box;
  border: 1px solid #cccccc;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  box-sizing: border-box;
  margin-right: 5px;
}
.typeRadio.checkActive {
  border: 4px solid #1890ff;
}

.tab {
  font-size: 13px;
  color: #999;
  width: 64px;
  height: 28px;
  line-height: 28px;
  text-align: center;
  border: 2px solid #f6f6f6;
  background: #f6f6f6;
}

.tab:first-child {
  border-radius: 8px 0 0 8px;
}

.tab:last-child {
  border-radius: 0 8px 8px 0;
}

.tab.current {
  color: #000;
  background: #fff;
}

.row-box {
  display: flex;
  align-items: center;
  padding-top: 5px;
}

.comment-text img {
  display: block;
  margin: 12px auto 0;
  width: 100%;
  height: 195px;
}

.mp-box {
  display: flex;
  align-items: center;
  font-size: 15px;
  columns: #666;
  padding: 10px;
  background-color: #f5f5f5;
}

.mp-box img {
  width: 45px;
  height: 45px;
  margin-right: 10px;
}

.mp-box div {
  flex: 1;
  line-height: 1.5;
  text-align: left;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.btn-page {
  font-size: 15px;
  padding: 0 12px;
  border-radius: 5px;
  background: #fff;
  color: #666;
  text-align: center;
  height: 32px;
  line-height: 32px;
  margin-right: 15px;
  border: 1px solid #ddd;
  box-sizing: border-box;
}

.btn-prev {
  float: left;
  margin-left: 5px;
}

.btn-next {
  float: right;
  margin-right: 5px;
}

.btn-page-panel {
  overflow: hidden;
  cursor: pointer;
}
.wrongbook-box {
  padding: 40px 0;
  background: white;
}

.wrongbook {
  height: 80px;
  background: url("https://cdn-xcxcustom.weiyoubot.cn/20210624/c160c6e0dd697cf613e7781d7b1ea58f.jpg");
  background-size: 100% 100%;
  border-radius: 8px;
  padding: 30px 0 30px 30px;
  box-sizing: border-box;
}

.wrongbook img {
  width: 20px;
  height: 20px;
  margin-left: 10px;
}

.wrongbook-title {
  display: flex;
  align-items: center;
  font-weight: bold;
  font-size: 36px;
  line-height: 54px;
  margin-bottom: 10px;
}

.wrongbook-count {
  font-size: 26px;
  line-height: 39px;
  font-weight: 350;
  letter-spacing: 2px;
}

.green {
  color: #00cf97;
}

.red {
  color: #ff5c5c;
}

.analysis-text {
  padding-top: 10px;
  white-space: pre-line;
}

.fillBlank > div {
  margin-bottom: 10px;
}

.fillBlank > div:last-child {
  margin-bottom: 0;
}

.fillBlank-single {
  margin: 20px 0;
}

.fillBlank-single div {
  line-height: 50px;
}

.wrongbook-nodata {
  font-size: 13px;
  line-height: 39px;
  color: #999999;
  text-align: center;
  padding: 30px 0;
  background: #fff;
}

.score-item {
  display: flex;
  justify-content: space-between;
}
.editScore {
  display: flex;
  align-items: center;
}
.editScore .icon {
  width: 30px;
  height: 30px;
  margin-right: 10px;
}

.editScoreModal {
  color: #999999;
}

.edit-input {
  display: flex;
  align-items: center;
}

.edit-input input {
  width: 100px;
  border-bottom: 2px solid #262626;
  text-align: center;
  display: inline-block;
  height: 40px;
}

.editScoreModal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 28px;
  line-height: 40px;
  color: #262626;
}

.origin-score {
  font-size: 24px;
  line-height: 36px;
  color: #999999;
}

.editScoreReason {
  background: #f8f8f8;
  border-radius: 4px;
  width: 600px;
  height: 120px;
  padding: 20px;
  box-sizing: border-box;
  font-size: 30px;
  margin: 20px 0;
  color: #000;
}

.edited-score {
  font-size: 30px;
  line-height: 42px;
  color: #00cf97;
}

.btn-group {
  margin-top: 30px;
  display: flex;
  justify-content: space-between;
}

.btn-group button {
  width: 290px;
  height: 90px;
  line-height: 90px;
  text-align: center;
  border-radius: 4px;
  background: #f8f8f8;
  font-size: 30px;
  color: #999999;
}

.btn-group .confirm {
  background: #1890ff;
  color: white;
}

.editRecord {
  background: #f8f8f8;
  border-radius: 4px;
  color: #999999;
  // font-size: 13px;
  // line-height: 20px;
  padding: 10px;
  margin-bottom: 15px;
}

.editRecord-item {
  margin-bottom: 5px;
}
.editRecord-item:last-child {
  margin-bottom: 0;
}
.dialog,
.dialog-mask {
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.4);
  z-index: 99;
}

.dialog-body {
  position: fixed;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  background: #fff;
  border-radius: 10px;
  z-index: 1001;
  padding: 30px;
  display: flex;
  display: -webkit-flex;
  flex-direction: column;
  align-items: center;
}

.pb40 {
  padding-bottom: 20px;
}

.banner {
  margin: 0 40px;
  height: 380px;
  padding-bottom: 30px;
}
.my-swipe {
  height: 100%;
}

.slide-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 4px;
}
.fillBox {
  border: 1px solid #eee;
  background-color: #fafafa;
  border-radius: 5px;
  display: flex;
  display: -webkit-flex;
  margin-bottom: 15px;
  padding: 10px 15px;
  align-items: center;
}
.f32 {
  font-size: 16px;
}
.f28 {
  font-size: 14px;
}
.f48 {
  font-size: 24px;
}
.f26 {
  font-size: 13px;
}
.f44 {
  font-size: 22px;
}
.f46 {
  font-size: 23px;
}
.pre_line {
  white-space: pre-line;
}
.blank-item {
  display: inline-block;
}
.new-title {
  font-weight: bold;
  font-size: 17px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.new-top {
  padding: 15px 10px;
  display: flex;
  display: -webkit-flex;
  justify-content: space-between;
  align-items: center;
  background: #f2f2f7;
  border-radius: 4px;
  margin-top: 10px;
}

.top-view {
  flex: 1;
  justify-content: space-between;
  text-align: center;
}
.top-view:first-child {
  max-width: 65px;
}
@media screen and (min-width: 500px) { // 当屏幕宽度大于或等于 500px 时应用的样式规则
  .top-view:first-child {
    max-width: 85px;
  }
}
.big {
  font-size: 17px;
  font-weight: bold;
  line-height: 25px;
}

.tip {
  font-size: 13px;
  color: #999;
  margin-top: 5px;
  line-height: 19px;
}
.joiner-avatar {
  border: 2px solid #ffffff;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  min-width: 30px;
  margin-right: 10px;
}
.user-info {
  border-top: 1px solid #eeeeee;
  margin-top: 20px;
  padding: 15px 0 5px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.user-c {
  flex: 1;
  margin-right: 10px;
}
.user-name {
  font-size: 15px;
  display: flex;
  align-items: center;
}
.name-text {
  max-width: 193px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.record-time {
  font-size: 12px;
  line-height: 16px;
  color: #999999;
}
.user-r {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.record-score {
  font-size: 20px;
  line-height: 29px;
  font-weight: bold;
  color: #1890ff;
}
.user-total {
  font-size: 12px;
  line-height: 16px;
  color: #999999;
}
.header-wrap {
  padding: 15px 15px 0;
}
.top-box {
  background: #ffffff;
  padding: 20px 15px 15px 15px;
  border-radius: 4px;
}
.wb-box {
  background: #ffffff;
  padding: 15px 15px 5px;
}

.redColor {
  color: #ff7070;
}

.fixed {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 99;
  max-width: 500px;
  margin: 0 auto;
}

.delete-box {
  width: 65px;
  height: 38px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: #999999;
  font-size: 12px;
  text-align: center
}
.delete-icon {
  width: 18px;
  height: 18px;
  margin-bottom: 5px;
}

.f-detail {
  flex: 1;
  height: 45px;
  line-height: 45px;
  color: #fff;
  font-size: 16px;
  border-radius: 4px;
  background-color: #1890FF;
  text-align: center;
}
.f-detail.l{
  margin-right: 15px;
  border: 1px solid #1890FF;
  background: #ffffff;
  color: #1890FF;
}
.f-detail.r {
  margin-left: 15px;
}
.divide-box {
  height: 1px;
  background: transparent;
  padding-bottom: 75px;
}
.edit-icon {
  width: 18px;
  height: 18px;
  padding: 7px;
  cursor: pointer;
}
.toggle-btn {
  color: #999999;
  font-size: 14px;
}
.hideComment {
  height: 0;
  overflow: hidden;
}
.info-box .top.hideTop {
  margin-bottom: 0;
  border-bottom: 0;
  padding-bottom: 0;
}
</style>



// WEBPACK FOOTER //
// src/pages/answer/answerNormal.vue